<mat-stepper linear #stepperHorLin [orientation]="(stepperOrientation | async)!" id="linearHorizontalStepper">

  <ng-template matStepperIcon="edit">
    <span aria-hidden="true">{{ stepperHorLin.selectedIndex + 1 }}</span>
  </ng-template>

  <mat-step [stepControl]="horizLinPersonalInfo">
    <div>
    </div>

    <form [formGroup]="horizLinPersonalInfo">
      <ng-template matStepLabel>
        <span aria-label="1 MCT Personal Info">MCT Personal Info</span>
      </ng-template>

      <div class="grid-layout">
        <div class="form-row">
          <mat-form-field class="form-field-flex">
            <input type="text" placeholder="First Name*" matInput formControlName="firstname" aria-label="First Name" />
            <mat-error
              *ngIf="!horizLinPersonalInfo.get('firstname')?.valid && horizLinPersonalInfo.get('firstname')?.touched && horizLinPersonalInfo.get('firstname')?.errors?.required">
              First name is required</mat-error>
            <mat-error
              *ngIf="horizLinPersonalInfo.get('firstname')?.touched && horizLinPersonalInfo.get('firstname')?.errors?.pattern">
              First name can contain only letters</mat-error>
          </mat-form-field>
          <mat-form-field class="form-field-flex">
            <input type="text" placeholder="Last Name*" matInput formControlName="lastname" aria-label="Last Name" />
            <mat-error
              *ngIf="!horizLinPersonalInfo.get('lastname')?.valid && horizLinPersonalInfo.get('lastname')?.touched && horizLinPersonalInfo.get('lastname')?.errors?.required">
              Last name is required</mat-error>
            <mat-error
              *ngIf="horizLinPersonalInfo.get('lastname')?.touched && horizLinPersonalInfo.get('lastname')?.errors?.pattern">
              Last name can contain only letters</mat-error>
          </mat-form-field>
        </div>

        <div class="email-note-group">
          <mat-form-field>
            <input type="text" placeholder="Email*" matInput formControlName="email" aria-label="Email" />
          </mat-form-field>
          <p class="email-note-text">
            <em>Email (Please use the email address associated with your MS Learn Profile)</em>
          </p>
        </div>
        <div style="display: flex; align-items: baseline; gap: 8px;">
          <mat-form-field>
            <input type="text" placeholder="Microsoft Learn transcript URL*" matInput
              formControlName="transScriptUrl" aria-label="Microsoft Learn transcript URL" />
            <mat-hint class="mat-error"
              *ngIf="( horizLinPersonalInfo.get('transScriptUrl')?.touched) &&(!horizLinPersonalInfo.get('transScriptUrl')?.valid || !horizLinPersonalInfo.get('transScriptUrl')?.value)"
              align="start">Please enter a valid URL (e.g., https://www.example.com)</mat-hint>
            <mat-hint class="hint-action" aria-label="Click here to verify the url"
              *ngIf="horizLinPersonalInfo.get('transScriptUrl')?.valid && horizLinPersonalInfo.get('transScriptUrl')?.value"
              align="end" tabindex="0" role="button" (click)="onClickTesturl()" (keydown.enter)="onClickTesturl()"
              (keydown.space)="onClickTesturl(); $event.preventDefault()">Click here to verify the url</mat-hint>
            <mat-hint class="divider"
              *ngIf="horizLinPersonalInfo.get('transScriptUrl')?.valid && horizLinPersonalInfo.get('transScriptUrl')?.value"
              align="end"><mat-divider [vertical]="true"></mat-divider>
            </mat-hint>
            <mat-hint align="end">
              <a href="javascript:void(0)" (click)="getTranscript()" class="hint-action" style="cursor: pointer;"
                tabindex="0" aria-label="How to access your Learn Transcript"
                (keydown.space)="getTranscript(); $event.preventDefault()" (keydown.enter)="getTranscript()">
                How to access your Learn Transcript?
              </a>
            </mat-hint>
          </mat-form-field>
        </div>

        <div style="display: flex; align-items: baseline; gap: 8px;">
          <mat-form-field>
            <mat-select placeholder="ISC Provider*" formControlName="iscpProvider" aria-label="ISC Provider"
              (selectionChange)="onSelectionChange($event)">
              <mat-option *ngFor="let option of iscpProviderList" [value]="option.code">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <mat-error>ISC provider is required</mat-error>
          </mat-form-field>
          <fa-icon class="tool-tip-icon" [icon]="icons.faInfoCircle" matIconSuffix
            matTooltip="Please select your ISC provider." matTooltipPosition="after" id="isc-provider-icon" tabindex="0"
            role="button" aria-label="More information about ISC Provider"
            aria-describedby="isc-provider-tip"></fa-icon>
          <span id="isc-provider-tip" class="cdk-visually-hidden">Please select your ISC provider.</span>
        </div>

        <div style="display: flex; align-items: baseline; gap: 8px;">
          <mat-form-field>
            <input type="text" placeholder="ISC Certification ID" matInput formControlName="iscpreferCode" aria-label="ISC Certification ID" />

          </mat-form-field>
          <fa-icon class="tool-tip-icon" [icon]="icons.faInfoCircle" matIconSuffix
            matTooltip="Please enter your ISC Certification ID if provided by your ISC." matTooltipPosition="after"
            id="iscp-certification-icon" tabindex="0" role="button"
            aria-label="More information about ISC Certification ID" aria-describedby="cert-id-tip"></fa-icon>
          <span id="cert-id-tip" class="cdk-visually-hidden">Please enter your ISC Certification ID if provided by your
            ISC.</span>
        </div>
        <div style="display: flex; align-items: baseline; gap: 8px;">
          <mat-form-field>
            <textarea matInput placeholder="Additional Information" #textarea maxlength="500" aria-label="Additional Information"
              formControlName="iscpDetails"></textarea>
            <mat-hint align="end">{{ textarea.value.length }} / 500</mat-hint>
          </mat-form-field>
          <fa-icon class="tool-tip-icon" [icon]="icons.faInfoCircle" matIconSuffix
            matTooltip="Please provide any additional details you believe are important for the MCT Program to review as part of your enrollment."
            matTooltipPosition="after" id="additional-info-icon" tabindex="0" role="button"
            aria-label="More information about Additional Details"
            aria-describedby="additional-info-tip"></fa-icon><span id="additional-info-tip" class="cdk-visually-hidden">
            Please provide any additional details you believe are important for the MCT Program to review as part of
            your enrollment.
          </span>
        </div>


        <mat-form-field>
          <input type="text" placeholder="Contact Email" matInput formControlName="alternateEmail" aria-label="Contact Email" />
          <mat-error
            *ngIf="(horizLinPersonalInfo.get('alternateEmail')?.touched) && horizLinPersonalInfo.get('alternateEmail')?.hasError('invalidEmail')">
            Please enter a valid MCT email address
          </mat-error>
        </mat-form-field>

      </div>
      <div class="step-action">
        <button *ngIf="isFromRenewal" mat-stroked-button matStepperPrevious (click)="previous()"
          id="linearStep1Previous" class="blue-border-btn" aria-label="Previous">
          Previous
        </button>

        <button mat-flat-button matStepperNext (click)="next()" id="linearStep1Next" class="btn-clr" aria-label="Next">
          Next
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="horizLinFavoriteThings">
    <form [formGroup]="horizLinFavoriteThings">
      <ng-template matStepLabel>
        <span aria-label="2 MCT Additional Info">MCT Additional Info</span>
      </ng-template>
      <div class="grid-layout" style="display: flex; flex-direction: column; gap: 8px;">

        <mat-form-field>
          <mat-select placeholder="Preferred Language*" formControlName="language" aria-label="Preferred Language">
            <mat-option *ngFor="let option of languageList" [value]="option.name">
              {{ option.name }}
            </mat-option>
          </mat-select>
          <mat-error>Language is required</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="Country*" formControlName="country" aria-label="Country">
            <mat-option *ngFor="let option of countryList" [value]="option.countryName">
              {{ option.countryName }}
            </mat-option>
          </mat-select>
          <mat-error>Country is required</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="Employment Type*" formControlName="employmentType" aria-label="Employment Type">
            <mat-option *ngFor="let option of employmentTypeList" [value]="option.value">
              {{ option.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="horizLinFavoriteThings.get('employmentType')?.errors?.['required']">Employment Type is required</mat-error>
          <mat-error *ngIf="horizLinFavoriteThings.get('employmentType')?.errors?.['fteEmploymentType']">As an FTE user, Employment Type must be Active Microsoft Employee</mat-error>
        </mat-form-field>
        <div class="topaz-checkbox-group-col">
          <p style="font-size: 13px; color: #595959; margin-bottom: 8px;margin-left:10px">
            <em>Note: You must review the MCT Program Agreement through the link below before you can check the box to accept
              it.</em>
          </p>
          <div class="basic-checkboxes">
            <mat-checkbox matInput formControlName="mctAgreement" [(ngModel)]="isCheckboxSelected" [ngClass]="{
                  'is-invalid': !isCheckboxSelected && formSubmitted
                }" class="white-check-icon" id="requiredCheckbox"
              style="--mdc-checkbox-selected-checkmark-color: white; --mat-checkbox-checkmark-color: white;">
            </mat-checkbox>
            <span class="agreement-text">By checking this box, I acknowledge that I have read and agree to the terms of the
              <a href="javascript:void(0)" [attr.aria-disabled]="isAgreementLinkDisabled"
                [attr.tabindex]="isAgreementLinkDisabled ? -1 : 0" [class.disabled-link]="isAgreementLinkDisabled"
                aria-live="polite" [attr.aria-label]="'MCT Program Agreement (downloads PDF file, 150KB)'"
                (click)="!isAgreementLinkDisabled && agrementDoc();$event.stopPropagation()"
                (keydown.enter)="!isAgreementLinkDisabled && agrementDoc(); $event.stopPropagation()">MCT Program Agreement</a></span>
          </div>
          <mat-error class="is-invalid" *ngIf="!isCheckboxSelected && formSubmitted">
            You must accept the Agreement to continue
          </mat-error>
        </div>
      </div>
      <div class="step-action">
        <button *ngIf="!isFromRenewal" mat-button matStepperPrevious id="linearStep2Previous" aria-label="Back">
          <fa-icon style="color:#666;font-weight:400" [icon]="icons.faArrowLeft"></fa-icon>
          <span class="backbtn-txt">Back</span>
        </button>
        <button *ngIf="isFromRenewal" mat-stroked-button matStepperPrevious class="blue-border-btn" aria-label="Previous">
          Previous
        </button>
        <button mat-flat-button class="btn-clr" [disabled]="status == 'OPEN' || disableSubmitButton" matStepperNext
          id="linearStep2Next" (click)="submit()" aria-label="Submit">Submit</button>
      </div>
    </form>
  </mat-step>
</mat-stepper>